<template>
  <div class="page page-iframe-page">
    <client-only>
      <div :id="containerId" class="page-iframe-page__container" />
      <div ref="iframeContentEl" class="page-iframe-page__content" v-html="iframeCode" />
    </client-only>
  </div>
</template>

<script lang="ts" setup>
import { computed, nextTick, onMounted, ref } from 'vue';
import { usePagesStore } from '~/stores/pages';
import { executeEmbeddedScripts } from '~/utils/embedScripts';

const pages = usePagesStore();
const iframeCode = computed(() => pages.currentPage?.iframe_code || '');
const containerId = computed(() => pages.currentPage?.container_id || 'iframePageContainer');
const iframeContentEl = ref<HTMLElement | null>(null);

onMounted(() => {
  nextTick(() => {
    if (!iframeContentEl.value || !iframeCode.value) {
      return;
    }
    executeEmbeddedScripts(iframeContentEl.value);
  });
});
</script>
